var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    r: 89,
    fill: "#F6F8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.125 98.3398H50.875V133.339C50.875 135.009 51.9787 136.481 53.5914 136.962C61.2526 139.24 82.7971 145.651 87.9039 147.171C88.6187 147.383 89.3813 147.383 90.0961 147.171C95.2029 145.651 116.747 139.24 124.409 136.962C126.021 136.481 127.125 135.009 127.125 133.339C127.125 124.574 127.125 98.3398 127.125 98.3398Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.125 98.3398H89C89 98.3398 88.6302 147.33 89 147.33C89.3698 147.33 89.7377 147.277 90.0961 147.171C95.2029 145.651 116.747 139.24 124.409 136.962C126.021 136.481 127.125 135.009 127.125 133.339C127.125 124.574 127.125 98.3398 127.125 98.3398Z",
    fill: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 110.608L50.875 98.3398C50.875 98.3398 44.1898 108.171 41.2008 112.565C40.8653 113.058 40.7833 113.677 40.9777 114.238C41.1741 114.8 41.6221 115.236 42.192 115.422C49.4339 117.755 70.8716 124.663 76.495 126.474C77.3013 126.735 78.1858 126.435 78.6624 125.737C81.2187 121.995 89 110.608 89 110.608Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.125 98.3398L89 110.608C89 110.608 96.7813 121.995 99.3376 125.737C99.8142 126.435 100.699 126.735 101.505 126.474C107.128 124.663 128.566 117.755 135.808 115.422C136.378 115.236 136.826 114.8 137.022 114.238C137.217 113.677 137.135 113.058 136.799 112.565C133.81 108.171 127.125 98.3398 127.125 98.3398V98.3398Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7718 72.5669C79.2953 71.8731 78.4127 71.5725 77.6063 71.8334C71.9867 73.6427 50.5433 80.5529 43.3015 82.8879C42.7315 83.0713 42.2816 83.508 42.0872 84.0695C41.8927 84.631 41.9747 85.2512 42.3102 85.7427C45.0628 89.7924 50.875 98.3381 50.875 98.3381L89 86.0282C89 86.0282 82.1528 76.04 79.7718 72.5669V72.5669Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.69 85.7427C136.025 85.2512 136.107 84.631 135.913 84.0695C135.718 83.508 135.269 83.0713 134.699 82.8879C127.457 80.5529 106.013 73.6427 100.394 71.8334C99.5873 71.5725 98.7047 71.8731 98.2282 72.5669C95.8472 76.04 89 86.0282 89 86.0282L127.125 98.3381C127.125 98.3381 132.937 89.7924 135.69 85.7427Z",
    fill: "#DDEBF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.125 98.3392L89 86.0293L50.875 98.3392L89 110.607L127.125 98.3392Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 110.607V86.0293L50.875 98.3392L89 110.607Z",
    fill: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3407 91.4585C80.5477 90.9442 79.8328 90.3941 79.1981 89.8174C78.4241 89.1122 77.2175 89.1633 76.5045 89.9327C75.7935 90.7003 75.845 91.8971 76.6208 92.6023C77.4005 93.3132 78.2792 93.99 79.2552 94.6234C80.1359 95.1944 81.3178 94.9486 81.8935 94.0751C82.4692 93.2016 82.2214 92.0294 81.3407 91.4585V91.4585Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4008 85.6511C74.8347 84.8892 74.3562 84.1235 73.9635 83.3578C73.4869 82.4276 72.3375 82.057 71.3996 82.5297C70.4617 83.0023 70.0881 84.1424 70.5647 85.0725C71.0488 86.0141 71.636 86.9575 72.3317 87.8934C72.9551 88.7328 74.1484 88.9124 74.9967 88.2942C75.8431 87.6741 76.0242 86.4905 75.4008 85.6511Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6139 77.9349C72.6329 77.173 72.7454 76.4337 72.9513 75.7247C73.241 74.7227 72.6558 73.6734 71.6436 73.386C70.6333 73.0987 69.5753 73.6791 69.2856 74.683C68.9939 75.6964 68.83 76.7532 68.8014 77.8403C68.7766 78.884 69.6077 79.7518 70.66 79.7763C71.7122 79.8028 72.5872 78.9785 72.6139 77.9349Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5457 71.6206C76.0356 71.1706 76.5846 70.7546 77.1851 70.3784C78.0753 69.8207 78.3422 68.6523 77.7817 67.7712C77.2194 66.8883 76.0413 66.6236 75.1511 67.1795C74.3448 67.6843 73.6128 68.242 72.9551 68.847C72.1831 69.556 72.1373 70.7528 72.8522 71.5185C73.567 72.2842 74.7737 72.3295 75.5457 71.6206Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.635 68.3579C83.5939 68.1821 84.6099 68.0687 85.6812 68.0252C86.7335 67.9798 87.5493 67.0969 87.5055 66.0551C87.4617 65.0134 86.5714 64.2023 85.5192 64.2458C84.2611 64.2987 83.0677 64.433 81.9412 64.6391C80.908 64.83 80.2217 65.8169 80.4142 66.8416C80.6049 67.8683 81.5999 68.547 82.635 68.3579V68.3579Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5704 68.2469C94.1964 68.2658 95.71 68.2091 97.1149 68.0862C98.1633 67.9935 98.9392 67.0747 98.8458 66.0349C98.7524 64.9969 97.8259 64.2274 96.7775 64.3201C95.4908 64.4316 94.1049 64.4845 92.6143 64.4656C91.562 64.4543 90.6985 65.2918 90.687 66.3336C90.6737 67.3772 91.5182 68.2355 92.5704 68.2469Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.381 66.9284C105.268 66.3555 106.862 65.622 108.196 64.7806C109.082 64.2191 109.345 63.0507 108.779 62.1697C108.215 61.2905 107.035 61.0296 106.147 61.5911C105.073 62.268 103.787 62.8503 102.266 63.3116C101.261 63.6179 100.693 64.6748 101.002 65.673C101.309 66.6713 102.376 67.2328 103.381 66.9284V66.9284Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.084 59.4874C113.983 57.6421 114.328 55.691 114.241 53.8098C114.191 52.7662 113.297 51.9608 112.247 52.0099C111.196 52.0591 110.382 52.9439 110.432 53.9857C110.493 55.2637 110.26 56.589 109.65 57.8425C109.193 58.7822 109.589 59.9147 110.537 60.3684C111.484 60.8222 112.626 60.427 113.084 59.4874V59.4874Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.869 47.1252C110.48 45.2629 108.594 43.966 106.539 43.5481C105.508 43.3402 104.5 43.9981 104.288 45.0209C104.078 46.0438 104.744 47.0439 105.773 47.2538C106.959 47.4939 108.003 48.3012 108.806 49.3769C109.433 50.2145 110.628 50.3903 111.473 49.7702C112.319 49.1482 112.496 47.9628 111.869 47.1252V47.1252Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.966 43.9153C89.0286 32.3315 106.903 33.0802 96.4973 43.9153H86.966Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.966 46.8496C89.0286 58.4316 106.903 57.6848 96.4973 46.8496H86.966Z",
    fill: "#CADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7945 47.293H99.5587C100.611 47.293 101.465 46.446 101.465 45.4023C101.465 44.3587 100.611 43.5117 99.5587 43.5117H86.7945C85.7441 43.5117 84.8882 44.3587 84.8882 45.4023C84.8882 46.446 85.7441 47.293 86.7945 47.293V47.293Z",
    fill: "#347BFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.d526c81c37fc0367508367e65c05e6ee.svg";
export { ForwardRef as ReactComponent };